//import css y Sass
require('./css/normalize.css');
require('bulma/css/bulma.min.css');
require('./sass/app.sass');
import AOS from 'aos';
import 'aos/dist/aos.css';

//flickyty
const Flickity = require('flickity');
require('./../node_modules/flickity/css/flickity.css');

//JS
require('./js/menu/menumovil');
require('./js/menu/submenu');

//paginas
require('./js/pages/_page');
require('./js/parts/parts');
require('./js/scroll/scroll');

require('./js/modules/slider');
require('./js/modules/formulario');
require('./js/templates/_templates');

//TESTs
require('./js/shared/shared.js');
require('./js/components/components.js');

AOS.init();
